import { ManualApiPayload, NovoCicloAutomacao } from '../../../types/ciclosApiType'
import {
  AprovarValidacaoCicloApibody,
  AprovarValidacaoResponse,
  ExecucaoCiclo,
  HistoricoExecucaoCicloResponse,
  ObterExecucoesCicloApiQuery
} from '../../../types/execucaoCicloTypes'
import { ResponsePaginado } from '../../../types/genericoType'
import { concatenarFiltrosQuery } from '../../../utils/stringUtils'
import api from '../../axiosInstance'

const listarExecucoesCicloApi = async (query: ObterExecucoesCicloApiQuery): Promise<ResponsePaginado<ExecucaoCiclo>> => {
  const URL_BUSCAR_EXECUCOES = `Automacao/ExecucaoCiclo${concatenarFiltrosQuery({
    pageNumber: query.pageNumber,
    pageSize: query.pageSize,
    parceiroId: query.parceiroId
  })}`
  const response = await api.conectarGet<ResponsePaginado<ExecucaoCiclo>>(URL_BUSCAR_EXECUCOES)
  return response.data
}

const aprovarValidacaoCicloApi = async (body: AprovarValidacaoCicloApibody): Promise<AprovarValidacaoResponse> => {
  const URL_APROVAR_VALIDACAO = `Automacao/Validacao/Aprovar`
  const response = await api.conectarPost<AprovarValidacaoResponse>(URL_APROVAR_VALIDACAO, body)
  return response.data
}

const gerarArquivoManual = async (parceiroId: string | number, payload: ManualApiPayload): Promise<NovoCicloAutomacao> => {
  const URL_GERAR_ARQUIVO_MANUAL = `Automacao/RepasseParceiro/${parceiroId}`
  const response = await api.conectarPost<NovoCicloAutomacao>(URL_GERAR_ARQUIVO_MANUAL, payload)
  return response.data
}

const listarHistoricoExecucaoCicloApi = async (cicloId: number): Promise<HistoricoExecucaoCicloResponse[]> => {
  const URL = `Automacao/HistoricoExecucaoCiclo/${cicloId}`
  const response = await api.conectarGet<HistoricoExecucaoCicloResponse[]>(URL)
  return response.data
}

export default {
  listarExecucoesCicloApi,
  aprovarValidacaoCicloApi,
  gerarArquivoManual,
  listarHistoricoExecucaoCicloApi
}
